export default __webpack_public_path__ + "static/telmotor-white-4ab437572fea16d47811133245257819.svg";